import i18next from 'i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

import Text from '@commons/Text';
import { Container } from '@commons/utils/genericStyledComponents';
import { ENUM_FONTS, ENUM_COLORS } from '@commons/Text/textEnums';
import { getTheme } from '@commons/utils/theme';

import { Logo, TextContainer, getButtonStyle } from './styledComponents';

const GlobalErrorBoundary = () => {
  const navigate = useNavigate();

  const theme = getTheme();

  return (
    <Container customStyle={{ backgroundColor: theme.colors.greys.darkest, gap: '48px' }}>
      <Logo alt="logo" src="/images/logo-inpulse.svg" />
      <TextContainer>
        <Text color={ENUM_COLORS.LIGHTEST} font={ENUM_FONTS.H1}>
          {i18next.t('ERROR_BOUNDARIES.TITLE')}
        </Text>
        <Text color={ENUM_COLORS.LIGHTEST} font={ENUM_FONTS.TEXT_SMALL}>
          {i18next.t('ERROR_BOUNDARIES.SUBTITLE')}
        </Text>
      </TextContainer>
      <Button variant="contained" onClick={() => navigate('/')} sx={getButtonStyle(theme)}>
        <img src="/images/home-white-small.svg" alt="" />
        <Text font={ENUM_FONTS.TEXT_SMALL_HEIGHT_24} color={ENUM_COLORS.LIGHTEST}>
          {i18next.t('GENERAL.HOME')}
        </Text>
      </Button>
    </Container>
  );
};

export default GlobalErrorBoundary;
